import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import LoanTransactionDisburseTrigger from './LoanTransactionDisburseTrigger'
import { actions as LKModalActions } from '../../LKModal'

export const actions = {
  open: (args) => LKModalActions.open({ name: 'LoanTransactionDisburse', ...args }),
}

export { LoanTransactionDisburseTrigger }

export default Loadable(() => import('./LoanTransactionDisburse'))
